import React from 'react';
export function AlternativeSection() {
  const scrollToBonuses = () => {
    const bonosSection = document.getElementById('bonos-exclusivos');
    if (bonosSection) {
      bonosSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-12 px-4 bg-[#0C0A09]" data-id="element-2">
      <div className="max-w-3xl mx-auto p-8 rounded-lg border border-red-500/20 bg-[#0C0A09] mb-16" data-id="element-3">
        <h3 className="text-2xl font-bold text-[#F5EDE0] mb-6 text-center" data-id="element-4">
          ❌ Si no compras esto, la alternativa es clara:
        </h3>
        <ul className="space-y-3 text-[#F5EDE0]/70" data-id="element-5">
          <li className="flex items-start gap-3" data-id="element-6">
            <span className="text-red-400 mt-1" data-id="element-7">•</span>
            <span data-id="element-8">seguir dudando durante semanas, meses o años</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-9">
            <span className="text-red-400 mt-1" data-id="element-10">•</span>
            <span data-id="element-11">seguir esperando señales que no llegan</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-12">
            <span className="text-red-400 mt-1" data-id="element-13">•</span>
            <span data-id="element-14">seguir pidiendo consejos que no aplicas</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-15">
            <span className="text-red-400 mt-1" data-id="element-16">•</span>
            <span data-id="element-17">seguir viviendo en pausa</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-18">
            <span className="text-red-400 mt-1" data-id="element-19">•</span>
            <span data-id="element-20">seguir posponiendo lo inevitable</span>
          </li>
        </ul>
        <p className="text-center text-[#F5EDE0] font-semibold mt-6 text-lg" data-id="element-21">
          Este producto elimina eso.
        </p>
      </div>

      {/* What Customer Buys */}
      <div className="max-w-2xl mx-auto mb-12 text-center" data-id="element-22">
        <h3 className="text-2xl font-bold text-[#CFA86A] mb-6" data-id="element-23">
          🟢 LO QUE COMPRA EL CLIENTE
        </h3>
        <div className="space-y-3 text-[#F5EDE0]/70 mb-6" data-id="element-24">
          <p data-id="element-25">🚫 No compras un libro</p>
          <p data-id="element-26">🚫 No compras tarot</p>
          <p data-id="element-27">🚫 No compras información</p>
        </div>
        <p className="text-2xl font-bold text-[#F5EDE0] leading-relaxed" data-id="element-28">
          Compras <span className="text-[#CFA86A]" data-id="element-29">certezas</span>. Compras{' '}
          <span className="text-[#CFA86A]" data-id="element-30">avance</span>. Compras tu{' '}
          <span className="text-[#CFA86A]" data-id="element-31">próxima decisión</span>.
        </p>

        <div className="mt-8" data-id="element-32">
          <button onClick={scrollToBonuses} className="bg-[#CFA86A] text-[#0C0F17] px-8 py-3 rounded-full font-bold text-lg hover:brightness-110 transition-all duration-300 shadow-[0_0_20px_rgba(207,168,106,0.3)] hover:shadow-[0_0_30px_rgba(207,168,106,0.5)] transform hover:-translate-y-1" data-id="element-33">
            Mirar ofertas
          </button>
        </div>
      </div>

      {/* Final CTA Text Only - Button moved back to PremiumBonusSection */}
      <div className="max-w-2xl mx-auto text-center" data-id="element-34">
        <h3 className="text-2xl font-bold text-[#F5EDE0] mb-4" data-id="element-35">
          🔥 Haz tu compra ahora y elimina la indecisión de tu vida.
        </h3>
        <p className="text-[#F5EDE0]/70 mb-8 text-lg" data-id="element-36">
          Cada día que dudas, pagas con tiempo lo que aquí puedes resolver con
          acción.
        </p>
      </div>
    </section>;
}